<template>
  <div>
    <v-btn
      block
      :color="
        providers.indexOf('google') >= 0
          ? themes.candidate.light.success
          : themes.candidate.light.primaryActionButton
      "
      @click="register('google')"
      :disabled="providers.indexOf('google') >= 0"
      :loading="oauthing === 'google'"
    >
      <v-icon left>{{ providers.indexOf('google') >= 0 ? 'mdi-check' : 'mdi-google' }}</v-icon>
      Google
    </v-btn>

    <v-btn
      block
      @click="showEmailSignup = showEmailSignup === 0 ? null : 0"
      :color="themes.candidate.light.primaryActionButton"
      class="ma-0"
      :disabled="loggedIn"
    >
      <v-icon left>{{ !providers.length && loggedIn ? 'mdi-check' : 'mdi-email' }}</v-icon>
      Email
    </v-btn>
    <v-expansion-panel v-model="showEmailSignup" class="mt-2 elevation-0">
      <v-expansion-panel-content :class="themes.candidate.light.primaryActionButton">
        <v-card flat>
          <v-card-text>
            <v-form @submit.prevent="register('email')" v-model="valid" ref="form">
              <v-text-field
                label="Email"
                v-model="auth.email"
                :rules="rules.email"
                required
                validate-on-blur
                type="email"
                hint="The address we'll use to send you notifications"
                ref="email"
                :error="errors.email && errors.email.length > 0"
                :error-messages="errors.email"
                @input="errors.email = null"
                :color="themes.candidate.light.input"
                @focus="$emit('scroll')"
                @keyup.enter="register('email')"
              />
              <v-text-field
                label="Password"
                v-model="auth.password"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :rules="rules.password"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                :error="errors.password && errors.password.length > 0"
                :error-messages="errors.password"
                class="input-group--focused"
                :color="themes.candidate.light.input"
                @focus="$emit('scroll')"
                @keyup.enter="register('email')"
              />
              <v-text-field
                label="Confirm Password"
                v-model="auth.confirmation"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :rules="[v => v === auth.password || 'Must match password given']"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                :error="errors.confirmation && errors.confirmation.length > 0"
                :error-messages="errors.confirmation"
                class="input-group--focused"
                :color="themes.candidate.light.input"
                @focus="$emit('scroll')"
                @keyup.enter="register('email')"
              />
            </v-form>
            <div class="text-xs-right">
              <v-spacer />
              <v-btn flat @click="showEmailSignup = null"> Cancel </v-btn>
              <v-btn
                :color="themes.candidate.light.primaryActionButton"
                @click="register('email')"
                :loading="loading"
                :disabled="!valid || loggedIn"
                type="submit"
              >
                Create
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
// Helpers
import _ from 'lodash'
import { mapGetters, mapState } from 'vuex'

// Validation
const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
  data() {
    return {
      // Model
      auth: {
        email: '',
        password: '',
        confirmation: '',
      },

      // Toggles
      showEmailSignup: null,
      showPassword: false,
      loading: false,
      oauthing: null,

      // Validation
      valid: true,
      rules: {
        email: [
          v => !!v || 'Email is required',
          v => emailPattern.test(v) || 'Email must be valid',
        ],
        password: [v => !!v || 'Password is required'],
      },
      errors: {},
    }
  },

  computed: mapGetters({
    campaign: 'campaign/model',
    loggedIn: 'auth/loggedIn',
    providers: 'auth/providers',
    profile: 'candidate/profile/model',
    user: 'auth/user',
  }),

  methods: {
    register(provider) {
      this.loading = true

      if (['google', 'facebook', 'linkedin'].indexOf(provider) >= 0) {
        this.oauthing = provider
        let auth = { provider }
        if (this.campaign) auth['campaignId'] = this.campaign.id

        this.$store
          .dispatch('auth/provider', { ...auth })
          .then(response => {
            if (response && response.error) {
              this.oauthing = null
              return
            }
            this.loadProfile()
          })
      }

      if (provider === 'email') {
        if (this.$refs.form.validate()) {
          let auth = this.auth
          if (this.campaign) auth['campaignId'] = this.campaign.id

          this.$store
            .dispatch('auth/register', { ...auth })
            .then(
              // Registration success
              response => {
                this.$store.dispatch('auth/login', { auth })
                  .then(() => this.$store.dispatch('auth/refresh'))
                  .then(this.loadProfile)
              },
              // Registration failure
              error => {
                // commit('setErrors', error.response.data.errors)
                this.$store.dispatch('snackbarError', "Your account couldn't be created.")
                this.errors = _.get(error, 'response.data.errors') ? error.response.data.errors : {}
                this.loading = false
              }
            )
            .finally(() => {
              this.oauthing = null
            })
        } else {
          this.loading = false
        }
      }
    },

    loadProfile() {
      this.loading = true
      this.$store.dispatch('candidate/profile/fetch').finally(() => {
        this.$emit('done', this.profile && this.profile.id ? 'existing' : 'new')
        this.$emit('input')
        this.oauthing = null
        this.loading = false
      })
    },
  },
}
</script>
